// Tạo file mới: src/components/SearchableSelect.js

import React, { useState, useMemo } from 'react';
import { ChevronDown, Search } from 'lucide-react';
import SearchDialog from './SearchDialog';

const SearchableSelect = ({
  value,
  onChange,
  options = [],
  placeholder = "Chọn...",
  displayField = "name",
  valueField = "id", 
  secondaryField = null,
  searchPlaceholder = "Tìm kiếm...",
  title = "Chọn",
  allowEmpty = true,
  emptyText = "Không chọn",
  className = "",
  disabled = false,
  required = false
}) => {
  const [showDialog, setShowDialog] = useState(false);

  // Find selected option for display
  const selectedOption = useMemo(() => {
    if (!value) return null;
    return options.find(option => option[valueField] === value) || null;
  }, [value, options, valueField]);

  const handleSelect = (selectedItem) => {
    if (selectedItem) {
      onChange(selectedItem[valueField]);
    } else {
      onChange(null);
    }
  };

  const getDisplayText = () => {
    if (!selectedOption) {
      return placeholder;
    }
    
    const primaryText = selectedOption[displayField];
    const secondaryText = secondaryField ? selectedOption[secondaryField] : null;
    
    if (secondaryText) {
      return `${primaryText} - ${secondaryText}`;
    }
    
    return primaryText;
  };

  return (
    <>
      {/* Select Button */}
      <button
        type="button"
        onClick={() => !disabled && setShowDialog(true)}
        disabled={disabled}
        className={`
          w-full px-3 py-2 text-left border rounded-lg 
          focus:ring-2 focus:ring-blue-500 focus:border-transparent
          flex items-center justify-between
          transition-colors
          ${disabled 
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200' 
            : 'bg-white border-gray-300 hover:border-gray-400 cursor-pointer'
          }
          ${!selectedOption ? 'text-gray-500' : 'text-gray-900'}
          ${className}
        `}
      >
        <span className="truncate flex-1">
          {getDisplayText()}
        </span>
        
        <div className="flex items-center ml-2 space-x-1">
          {options.length > 10 && (
            <Search className="w-4 h-4 text-gray-400" />
          )}
          <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${showDialog ? 'transform rotate-180' : ''}`} />
        </div>
      </button>

      {/* Required indicator */}
      {required && !selectedOption && (
        <div className="text-xs text-red-500 mt-1">
          Trường này là bắt buộc
        </div>
      )}

      {/* Search Dialog */}
      <SearchDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        onSelect={handleSelect}
        items={options}
        title={title}
        searchPlaceholder={searchPlaceholder}
        displayField={displayField}
        valueField={valueField}
        secondaryField={secondaryField}
        selectedValue={value}
        allowEmpty={allowEmpty}
        emptyText={emptyText}
      />
    </>
  );
};

export default SearchableSelect;